// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"3c24db89","823":"ba44f601"}[chunkId] + ".chunk.js");